import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/App.css';

class VerifySlipOptions extends Component {

  handleExternalLink = (url) => {
    window.location.href = url; // Navigate to the external URL in the same window
  };

  render() {
    return (
      <div className='App'>
        <img className='logo' src={logo} alt="Logo" />
        <br />
        <div>
          How do you want to verify your bank's slip...
        </div>
        <br />
        <div><Link to='/login9'>Verify by Uploading</Link></div>
        <br />
        <div><Link to='/login10'>Verify by Scanning</Link></div>
        <br />
        <br />
        <div>Powered by</div>
        <img className='logo2' src={logo2} alt="Logo 2" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default VerifySlipOptions;
